import React from "react";

import styled, { css } from "styled-components";
import { IBlockHeaderStyleProps, IStatusMarkerStyleProps } from "./interfaces";

export const Block = styled.div`
    padding: 8px;
    border: ${p => p.theme.mode === "dark" ? "0" : "1px"} solid #ccc;
    border-radius: 12px;
    background-color: ${p => p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.light};
    margin-bottom: 12px;
`;

export const BlockHeader = styled.div<IBlockHeaderStyleProps>`
    display: flex;
    cursor: pointer;
    position: sticky;
    top: 50px;
    background: ${p => p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.light};
    z-index: 1;
    margin-top: -8px;
    padding-top: 8px;
    ${p =>
        p.isOpen &&
        css`
            margin-bottom: 8px;
        `}
`;

const StyledCaret = styled.div`
    position: absolute;
    top: 20px;
    right: 10px;
    pointer-events: none;

    svg {
        display: block;
        polygon {
            fill: ${p => p.theme.c.grey7};
        }
    }
`;

export const Caret = () => (
    <StyledCaret>
        <svg width="11" height="6">
            <polygon points="0,0 11,0 5.5,5.5" />
        </svg>
    </StyledCaret>
);

export const LevelName = styled.div`
    flex: 1;
    font-weight: 600;
    font-size: 18px;
`;

const statusColors = ["disabled", "info", "info", "active", "correct"];

export const StatusMarker = styled.div<IStatusMarkerStyleProps>`
    background-color: ${p => p.theme.c[statusColors[p.levelStatus]]};
    margin-right: 30px;
    padding: 0 6px;
    border-radius: 6px;
    font-weight: 600;
    height: 28px;
    margin-left: 6px;
    color: ${p => (p.levelStatus === 1 || p.levelStatus === 2 ? p.theme.c.dark : p.theme.c.whiteOnActive)};
`;

export const BlockContent = styled.div`
    padding: 4px;
`;

export const MergeButton = styled.button`
    height: 28px;
    padding: 0px 4px;
    font-size: 16px;
    margin-bottom: 0;
`;
